module.exports = __webpack_public_path__ + "img/lv4_2_1.8459bc87.png";